export default ({ next, auth, store, routerNext }) => {
  const data = auth.getAuthDecode()
  if (data && data.role === 'owner') {
    if (store.getters['Style/errorPage']) {
      store.dispatch('Style/setErrorPage', 0)
    }
    return routerNext()
  }
  if (!store.getters['Style/errorPage']) {
    store.dispatch('Style/setErrorPage', 403)
  }
  return next()
}
